import { Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { useCompany } from "store/models";
import UserArea from "./UserArea";

export default function Header(){
  const company = useCompany();
  const history = useHistory();

  function renderCompanyView(){
    if(company.connected){
      return (
        <div id="header-company-view">
          <label>{company.name}</label>
          {company.cleanable?(
            <Button onClick={()=>{
              company.clear();
              history.push(`company`)
            }}>Voltar</Button>
          ):""}
        </div>
      );
    }
    return <></>;
  }

  return <div id="masterpage-header">
    {/* <div className="only-to-style"></div> */}
    <div id="masterpage-header-logo">
      <img alt="sim-logo-hw" src="/images/logo-sim-hw.png"></img>
    </div>
    {renderCompanyView()}
    <UserArea/>
  </div>
}